import { GoalConfigCard } from "@/cards/GoalConfigCard";
import { SimpleDonoGoalWidget } from "@/Components/SimpleDonoGoalWidget/SimpleDonoGoalWidget";
import { useSocket } from "@/hooks/useSocket";
import { AnyGoalDoc, NewGoalUpdateEvent, NewSimpleGoalDoc } from "@ailenax-overlay/shared";
import { FC, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export const Goal: FC = () => {
    const { id } = useParams();
    const socket = useSocket();
    const [goal, setGoal] = useState<AnyGoalDoc | null>(null);

    useEffect(() => {
        socket.emit("get-new-goals", gs => {
            const foo = gs.find(bar => bar._id === id);
            if (foo) {
                setGoal(foo);
            }
        });

        const onNewGoalUpdate = (e: NewGoalUpdateEvent) => {
            if (e.goal._id === id) {
                setGoal(e.goal);
            }
        }

        socket.on("new-goal-update", onNewGoalUpdate);

        return () => {
            socket.off("new-goal-update", onNewGoalUpdate);
        }
    }, [id, socket]);

    const setSimpleField = <F extends keyof NewSimpleGoalDoc>(field: F, value: NewSimpleGoalDoc[F]) => {
        setGoal((prev) => {
            return {
                ...prev,
                [field]: value
            } as NewSimpleGoalDoc;
        });
    };

    const doSave = useCallback(() => {
        socket.emit("save-new-goal", goal);
    }, [socket, goal]);

    const resetSimple = useCallback((modulo: boolean = false) => {
        if (!goal || goal.goalType !== "simple") {
            return;
        }
        const resetTo = modulo ? goal.progress % goal.goal : 0;
        socket.emit("save-new-goal", {
            ...goal,
            progress: resetTo
        });
    }, [socket, goal]);

    if (!goal) {
        return null;
    }

    return (
        <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12">
                <div className="min-w-3xl max-w-max m-auto">
                    { goal.goalType === "simple" && <SimpleDonoGoalWidget goal={goal} /> }
                </div>
            </div>
            { goal.goalType === "simple" && <GoalConfigCard goal={goal} setField={setSimpleField} doSave={doSave} reset={resetSimple}/> }
        </div>
    )
}